import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=33f325ac"
import script from "./Carousel.ts?vue&type=script&lang=ts&external"
export * from "./Carousel.ts?vue&type=script&lang=ts&external"
import style0 from "./Carousel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports